jQuery( document ).on(
	'click',
	'#cookie-policy',
	function(e){
		e.preventDefault();
		CLI.settingsModal.addClass( "cli-show" ).css( {'opacity':0} ).animate( {'opacity':1} );
		CLI.settingsModal.removeClass( 'cli-blowup cli-out' ).addClass( "cli-blowup" );
		jQuery( 'body' ).addClass( "cli-modal-open" );
		jQuery( ".cli-settings-overlay" ).addClass( "cli-show" );
		jQuery( "#cookie-law-info-bar" ).css( {'opacity':.1} );
		if ( ! jQuery( '.cli-settings-mobile' ).is( ':visible' )) {
			CLI.settingsModal.find( '.cli-nav-link:eq(0)' ).trigger( "click" );
		}
	}
);

var timeoutId;
var jQueryvideoBgAspect = jQuery(".videobg-aspect");
var jQueryvideoBgWidth = jQuery(".videobg-width");
var videoAspect = jQueryvideoBgAspect.outerHeight() / jQueryvideoBgAspect.outerWidth();

function videobgEnlarge() {
  console.log('resize');
  windowAspect = (jQuery(window).height() / jQuery(window).width());
  if (windowAspect > videoAspect) {
    jQueryvideoBgWidth.width((windowAspect / videoAspect) * 100 + '%');
  } else {
    jQueryvideoBgWidth.width(100 + "%")
  }
}

jQuery(window).resize(function() {
  clearTimeout(timeoutId);
  timeoutId = setTimeout(videobgEnlarge, 100);
});

jQuery(function() {
  videobgEnlarge();
});